import {connect} from '../../app/connect';
import IssueLocationPicker from './IssueLocationPicker';
import {getLocationsTreeNodes, getIsLocationsLoadingError, getIsLocationsTreeLoading} from '../../app/selectors';
import LocationsThunk from '../../app/thunk/locationsThunk';

const mapStateToProps = state => ({
  locationsTreeNodes: getLocationsTreeNodes(state),
  isLoading: getIsLocationsTreeLoading(state),
  loadingError: getIsLocationsLoadingError(state)
});

const mapDispatchToProps = {
  getDefaultLocationTree: LocationsThunk.getDefaultTree
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueLocationPicker);
